export class Person {
    id: number;
    firstName: string;
    lastName: string;
    username: string;
    email: string;
    phoneNumber: string;
    address: string;
    paid: boolean;
    superAdmin: boolean;
    showWelcome: boolean;
    areaId: number;
    lineId: number;
    token?: string;

    public getDisplayName(): string {
        return this.firstName + ' ' + this.lastName + ' [' + this.username + ']';
    }

    public getDisplayNameForPerson(p: Person): string {
        return p.firstName + ' ' + p.lastName + ' [' + p.username + ']';
    }
}